module.exports = __webpack_public_path__ + "static/media/Edit_2.3ff881c5.png";